import VideoOverlayPortrait from "@components/Modules/VideoOverlayPortrait/VideoOverlayPortrait";
import { DataSource } from "@pub/config";
import { ReactNode } from "react";

import { extractHomeContentData, HomeLayoutProps } from "./utils";

type Props = {
  data: HomeLayoutProps["data"];
  dataSource: DataSource;
};

export default function HomeVideoOverlay({
  data,
  dataSource,
}: Props): ReactNode {
  const ContentVideoBlock = extractHomeContentData(data, dataSource);

  return <VideoOverlayPortrait content={ContentVideoBlock} />;
}
